import { validator } from '../core'

function testPasswordMatch(value: unknown) {
  return this.parent.newPassword === value
}

const minChar = 8

export const passwordValidation = (name: string) => {
  return validator
    .string()
    .required(`${name} is required.`)
    .min(minChar, `Password must contain at least ${minChar} characters`)
    .minLowercase(1, 'Password must contain 1 lowercase letter')
    .minSymbols(1, 'Password must contain 1 symbol')
    .minUppercase(1, 'Password must contain 1 uppercase letter')
    .test('passwords-match', 'Passwords must match', testPasswordMatch)
}
